import styled from 'styled-components';
import { Card as ConstellationCard } from '@zillow/constellation';

// width is 50% minus half the width of the gap ("md" or 24px)
const halfScreenWidth = 'calc(50% - 12px)';

export const Card = styled(ConstellationCard)<{ useFullScreen: boolean; height?: number }>`
    position: relative;
    width: ${({ useFullScreen }) => (useFullScreen ? '100%' : halfScreenWidth)};
    ${({ height }) => height && `height: ${height}px;`}
    display: flex;
    flex-direction: column;
`;
